export enum CookieSetting {
    NotDefined,
    Allowed,
    Rejected
}